import {classNames} from '@cohort/shared-frontend/utils/classNames';
import {Loader} from '@cohort/wallet/components/Loader';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import {Colors} from '@cohort/wallet/lib/Theme';
import {DownloadSimple} from '@phosphor-icons/react';
import {useTranslation} from 'react-i18next';

type PdfDownloadCardProps = {
  onDownloadClick: () => void;
  isLoading?: boolean;
};

const PdfDownloadCard: React.FC<PdfDownloadCardProps> = ({
  onDownloadClick,
  isLoading = false,
}: PdfDownloadCardProps) => {
  const {accentColor, hasDarkBg} = useThemeContext();
  const {t} = useTranslation('components', {keyPrefix: 'card.pdfDownloadCard'});

  return (
    <div
      className={classNames(
        'flex w-full cursor-pointer flex-row items-center justify-between rounded-lg p-4',
        hasDarkBg ? 'bg-white/5' : 'bg-black/5'
      )}
      onClick={onDownloadClick}
    >
      <p className="font-medium ">{t('labelPDF')}</p>
      {isLoading ? (
        <div className="relative h-6 w-6">
          <Loader color={hasDarkBg ? Colors.White : Colors.Black} />
        </div>
      ) : (
        <DownloadSimple style={{color: accentColor}} className="h-6 w-6" aria-hidden="true" />
      )}
    </div>
  );
};

export default PdfDownloadCard;
